export function _TRANSLATE(str: string) {
    return str;
}